export default __webpack_public_path__ + "static/media/location-black.1281d54a.svg";